import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-alert-erro-dados',
    templateUrl: './alert-erro-dados.component.html',
    styleUrls: ['./alert-erro-dados.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterLink]
})
export class AlertErroDadosComponent {

  @Input() alertErroDados: boolean = true;
  @Output() alertIgnorarDadosFechou = new EventEmitter();

  constructor() { }

  ignorarErros() {
      this.alertIgnorarDadosFechou.emit('Fechou');
  }
}
